import PropTypes from 'prop-types';
import LocationIcon from '../../Svg/Location';
import { SubscriptionDivider } from '../index';
import styles from './SubscriptionList.module.scss';
import { showAll } from './SubscriptionLinkFilter';
import { InfoOutlined } from 'uiKit/atoms/InfoOutlined/InfoOutlined';
import { Alert } from 'uiKit/atoms/Alert/Alert';

const TypeWithIcon = ({ lotType, productType, lotState }) => {
  const lotTypes = new Proxy(
    {
      Offer: { color: '#725198', placeholder: 'Offer' },
      LookingFor: { color: '#f39200', placeholder: 'Looking For' },
      default: { color: '#04A87D', placeholder: 'All' },
    },
    {
      get: (target, field) => {
        if (field in target) return target[field];
        return target.default;
      },
    }
  );

  const color = lotTypes[lotType].color;
  // TODO: Consider what this placeholder variable is needed for
  const placeholder = lotTypes[lotType].placeholder;

  return (
    <div className={styles.type}>
      <p className={styles.icon} style={{ backgroundColor: color }}>
        {placeholder}
      </p>
      {productType && (
        <p className={styles.value} style={{ color }}>
          {productType} {lotState ? `: ${lotState}` : ''}
        </p>
      )}
    </div>
  );
};

const Location = ({ data }) => {
  if (data && data.length > 0) {
    if (data.length === 1) {
      return <p className={styles.value}>{data[0].name}</p>;
    }
    return (
      <>
        <p className={styles.value_multiple}>Locations</p>
        <ul className={styles.value_multiple_submenu}>
          {data.map((el, i) => (
            <li key={i}>{el.name}</li>
          ))}
        </ul>
      </>
    );
  }
  return null;
};

const getConcateCategoryesString = item => {
  let categoryValue = '';
  let parentCategoryValue = '';

  if (item.category?.name) {
    categoryValue = item.category.name;
    if (item.category?.parentName) {
      parentCategoryValue = `${item.category.parentName} /`;
    }
  } else {
    categoryValue = 'All categories';
  }
  return `${parentCategoryValue} ${categoryValue}`;
};

const SubscriptionList = ({ subscriptions, cancelSubscription }) =>
  subscriptions?.length ? (
    subscriptions.map(sub => (
      <div key={sub.id} className={styles.bns3_subscriptionCard}>
        <div className={styles.row}>
          <div className={styles.category}>
            <p className={styles.label}>Category:</p>
            <p className={styles.value}>{getConcateCategoryesString(sub)}</p>
          </div>
          <TypeWithIcon productType={sub.productType} lotState={sub.lotState} lotType={sub.lotType} />
        </div>
        {sub.tags && sub.tags.length > 0 && (
          <div className={styles.row}>
            {sub.tags.map((el, i) => (
              <div key={i + el.value} className={styles.tag}>
                <p className={styles.value}>{el.name}</p>
              </div>
            ))}
          </div>
        )}
        {sub.query && (
          <div className={styles.row}>
            <div className={styles.query}>
              <p className={styles.label}>Search by: </p>
              <p className={styles.value}>{sub.query}</p>
            </div>
          </div>
        )}
        {sub.locations[0] && (
          <div className={styles.row}>
            <div className={styles.price}>
              {/* <p className={styles.label}>Price: </p>
            <p className={styles.value}>from £5 to £200</p> */}
            </div>
            <div className={styles.location}>
              {sub.locations[0]?.name && (
                <div className={styles.icon}>
                  <LocationIcon />
                </div>
              )}
              <Location data={sub.locations} />
            </div>
          </div>
        )}
        <SubscriptionDivider />
        <div className={styles.bns3_subscriptionActions}>
          <button className={styles.bns3_subscriptionShowAll} onClick={() => showAll(sub)}>
            Show All
          </button>
          <button
            className={styles.bns3_subscriptionRemoveSearch}
            type="button"
            onClick={() => cancelSubscription(sub.id)}
          >
            Remove search
          </button>
        </div>
      </div>
    ))
  ) : (
    <>
      <span className={styles.bns3_no_subscriptions_title}>
        No subscriptions yet
      </span>
      <Alert
        icon={<InfoOutlined fontSize="inherit" />}
        severity="info"
        className={styles.bns3_no_subscriptions_info}
      >
        <span className={styles.bns3_no_subscriptions_message}>
          You can subscribe to updates about lots that may interest you by pressing <strong>“ADD NEW SUBSCRIPTION”</strong>.<br /> You will be directed to the Home Page where you'll be able to choose the relevant filters and save your subscription.
          You can create multiple subscriptions.<br/> Once created, you will start receiving email notifications at the frequency you choose below.
        </span>
      </Alert>
    </>
  );

SubscriptionList.displayName = 'SubscriptionList';

SubscriptionList.propTypes = {
  subscriptions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      productType: PropTypes.string,
    })
  ),
  cancelSubscription: PropTypes.func,
};

export default SubscriptionList;
